export default {
  MuiLink: {
    styleOverrides: {
      root: {
        color: '#0075FE'
      }
    }
  }
};
